<app-users *ngIf="roleName === 'System Administrator'"></app-users>
<!--<p>dashboard works!</p>-->
<app-administrator-dashboard *ngIf="roleName === 'Administrator'"></app-administrator-dashboard>
<app-referee-dashboard *ngIf="roleName === 'Referee' || roleName === 'Limited Referee'"></app-referee-dashboard>
